<template>
  <span
    class="inline-flex items-center justify-center gap-1.5 rounded-full border text-xs font-medium px-2.5 py-0.5"
    :class="statusMeta.color"
    v-bind="$attrs"
  >
    <i :class="statusMeta.icon" class="text-[10px]"></i>
    {{ statusMeta.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { TaxInjectorRecordStatus } from '@/types/taxInjector'

interface StatusMeta {
  label: string
  icon: string
  color: string
}

const STATUS_CONFIG: Record<TaxInjectorRecordStatus, StatusMeta> = {
  PENDING: {
    label: 'Pending',
    icon: 'pi pi-clock',
    color: 'bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800',
  },
  COMPLETED: {
    label: 'Completed',
    icon: 'pi pi-check-circle',
    color: 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 border-green-200 dark:border-green-800',
  },
  ALREADY_PROCESSED: {
    label: 'Already Processed',
    icon: 'pi pi-info-circle',
    color: 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800',
  },
  SKIPPED: {
    label: 'Skipped',
    icon: 'pi pi-minus-circle',
    color: 'bg-surface-50 dark:bg-surface-800 text-surface-700 dark:text-surface-200 border-surface-200 dark:border-surface-700',
  },
  ERROR: {
    label: 'Error',
    icon: 'pi pi-times-circle',
    color: 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 border-red-200 dark:border-red-800',
  },
}

const props = defineProps<{
  status: TaxInjectorRecordStatus
}>()

const statusMeta = computed(
  () => STATUS_CONFIG[props.status] || STATUS_CONFIG.PENDING,
)
</script>

